import React, { useState, useCallback } from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { VideoIcon } from '@/assets/icons';
import { useKimLhc } from '@/context/KimLhc';
import { VideoDrawer } from '@/components/views/Report/KimLhc/Components/Shared/VideoDrawer';

import { PageTitle, LinkButton } from '@/components/views/Report/KimLhc/Components/Shared/styles';

interface VideoDrawerHeaderProps {
	title: string;
}

export function VideoDrawerHeader({ title }: Readonly<VideoDrawerHeaderProps>): JSX.Element {
	const { videoInfo, videoUrl } = useKimLhc();
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	const handleOpenDrawer = useCallback(() => {
		setIsDrawerOpen(true);
	}, []);

	const handleCloseDrawer = useCallback(() => {
		setIsDrawerOpen(false);
	}, []);

	return (
		<>
			<Col span={24}>
				<Row gutter={40} align="middle" justify="space-between">
					<Col flex="1">
						<PageTitle level={4}>{title}</PageTitle>
					</Col>
					<Col>
						<LinkButton type="link" icon={<VideoIcon width={20} height={20} />} onClick={handleOpenDrawer}>
							{I18n.get('View video')}
						</LinkButton>
					</Col>
				</Row>
			</Col>

			<VideoDrawer open={isDrawerOpen} onClose={handleCloseDrawer} videoUrl={videoUrl} videoInfo={videoInfo} />
		</>
	);
}
